import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Row, Col, Collapse, Skeleton } from 'antd';
import { styled } from '@xstyled/styled-components';
import { styleVariables } from '@lib/common';
import { QuestionType } from '@module/form';
import { DecimalNumber } from '@module/assignment';
import { QuestionSummaryButton } from './question-summary-button.component';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Panel = Collapse.Panel;
var SectionSummaryPart = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 100%;\n  padding-bottom: 16px;\n\n  /* &::-webkit-scrollbar {\n    display: none;\n  } */\n"])));
var StyledCollapse = styled(Collapse)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  height: 100%;\n\n  background: ", ";\n\n  .ant-collapse-content-box {\n    padding: 0 12px 12px 12px !important;\n  }\n\n  .ant-collapse-header-text {\n    font-size: ", ";\n  }\n\n  .ant-collapse-header {\n    padding: 12px !important;\n  }\n"])), styleVariables.colors.gray1, styleVariables.font.fontSizeSmall);
var SectionPanel = styled(Panel)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  margin-bottom: 15px;\n\n  background: ", ";\n\n  border: 1px solid\n    ", " !important;\n  border-radius: 8px !important;\n\n  &:last-child {\n    border-bottom: 1px solid ", ";\n    margin-bottom: 0 !important;\n  }\n"])), styleVariables.colors.gray1, function (props) {
  return props.selected ? styleVariables.colors.blue3 : styleVariables.colors.gray9;
}, styleVariables.colors.gray9);
var PanelContent = styled(Row)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var QuestionItemColumn = styled(Col)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  margin-bottom: 8px;\n"])));
var StyledTotalScore = styled.p(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n\n  font-size: 12px;\n  margin-bottom: 0;\n"])), styleVariables.colors.gray10);
export var SubmissionSectionSummary = function SubmissionSectionSummary(props) {
  var label = props.label,
      sectionSummaries = props.sectionSummaries,
      onSelectSection = props.onSelectSection,
      onSelectQuestion = props.onSelectQuestion,
      questionReleases = props.questionReleases,
      readonly = props.readonly,
      answers = props.answers,
      selectedSectionId = props.selectedSectionId,
      isAssignmentEnded = props.isAssignmentEnded;
  var getTooltipContent = useCallback(function (answer) {
    return "".concat(answer.score, " ").concat(label.score);
  }, [label.score]);
  var renderPanels = useCallback(function () {
    return sectionSummaries.map(function (section, index) {
      var matchingQuestions = questionReleases === null || questionReleases === void 0 ? void 0 : questionReleases.filter(function (q) {
        return q.sectionId === section.id.toString();
      });

      var renderQuestionItems = function renderQuestionItems() {
        return matchingQuestions === null || matchingQuestions === void 0 ? void 0 : matchingQuestions.map(function (question) {
          var answer = answers === null || answers === void 0 ? void 0 : answers.find(function (a) {
            return a.questionId === question.id.toString();
          });

          if (question.type === QuestionType.FillInBlank) {
            var fillInBlankAnswer = answer;
            return fillInBlankAnswer.answers.map(function (fillInBlankAnswer, index) {
              return /*#__PURE__*/_jsx(QuestionItemColumn, {
                children: /*#__PURE__*/_jsx(QuestionSummaryButton, _objectSpread(_objectSpread({
                  questionIndex: index + question.index,
                  active: fillInBlankAnswer.hasGraded(),
                  onClick: function onClick() {
                    onSelectQuestion(question.id.toString());
                    onSelectSection(section.id.toString());
                  },
                  disabled: readonly
                }, fillInBlankAnswer.hasGraded() && {
                  tooltipText: getTooltipContent(fillInBlankAnswer)
                }), {}, {
                  danger: fillInBlankAnswer.hasGraded() && fillInBlankAnswer.score === 0
                }))
              }, question.id.toString());
            });
          }

          if (question.type === QuestionType.Matching) {
            var _matchingAnswerGroup$;

            var matchingAnswerGroup = answer;
            return (_matchingAnswerGroup$ = matchingAnswerGroup.answers) === null || _matchingAnswerGroup$ === void 0 ? void 0 : _matchingAnswerGroup$.map(function (matchingAnswer, index) {
              return /*#__PURE__*/_jsx(QuestionItemColumn, {
                children: /*#__PURE__*/_jsx(QuestionSummaryButton, _objectSpread(_objectSpread({
                  questionIndex: index + question.index,
                  active: matchingAnswer.hasGraded(),
                  onClick: function onClick() {
                    onSelectQuestion(question.id.toString());
                    onSelectSection(section.id.toString());
                  },
                  disabled: readonly
                }, matchingAnswer.hasGraded() && {
                  tooltipText: getTooltipContent(matchingAnswer)
                }), {}, {
                  danger: matchingAnswer.hasGraded() && matchingAnswer.score === 0
                }))
              }, question.id.toString());
            });
          }

          return /*#__PURE__*/_jsx(QuestionItemColumn, {
            children: /*#__PURE__*/_jsx(QuestionSummaryButton, _objectSpread(_objectSpread({
              questionIndex: question.index,
              active: answer.hasGraded(),
              onClick: function onClick() {
                onSelectQuestion(question.id.toString());
                onSelectSection(section.id.toString());
              },
              disabled: readonly
            }, answer.hasGraded() && {
              tooltipText: getTooltipContent(answer)
            }), {}, {
              danger: answer.hasGraded() && answer.score === 0
            }))
          }, question.id.toString());
        });
      };

      var sectionAnswers = answers === null || answers === void 0 ? void 0 : answers.filter(function (a) {
        return a.sectionId === section.id.toString();
      });
      var totalSectionAnswerScore = sectionAnswers === null || sectionAnswers === void 0 ? void 0 : sectionAnswers.reduce(function (total, answer) {
        if (answer.hasGraded()) {
          return total + answer.score;
        }

        return total;
      }, 0);
      return /*#__PURE__*/_jsx(SectionPanel, _objectSpread(_objectSpread({
        header: /*#__PURE__*/_jsx("strong", {
          children: "".concat(label.section, " ").concat(index + 1)
        })
      }, totalSectionAnswerScore !== null && isAssignmentEnded && {
        extra: /*#__PURE__*/_jsx(StyledTotalScore, {
          children: "".concat(DecimalNumber.roundNumber(totalSectionAnswerScore), "/").concat(section.totalScore, " ").concat(label.score)
        })
      }), {}, {
        selected: selectedSectionId === section.id.toString(),
        showArrow: false,
        children: /*#__PURE__*/_jsx(PanelContent, {
          gutter: 8,
          children: renderQuestionItems()
        })
      }), section.id.toString());
    });
  }, [answers, getTooltipContent, isAssignmentEnded, label.score, label.section, onSelectQuestion, onSelectSection, questionReleases, readonly, sectionSummaries, selectedSectionId]);

  if (!sectionSummaries || !answers) {
    return /*#__PURE__*/_jsx(Skeleton, {
      paragraph: {
        rows: 10
      }
    });
  }

  return /*#__PURE__*/_jsx(SectionSummaryPart, {
    children: /*#__PURE__*/_jsx(StyledCollapse, {
      defaultActiveKey: sectionSummaries.map(function (section) {
        return section.id.toString();
      }),
      bordered: false,
      children: renderPanels()
    })
  });
};